<template>
  <div class="callBids">
    <div class="w">
      <topFilterBox @change="chooseCity">
        <div class="filter_box" slot="first">
          <div class="filter_title">
            招标类型:
          </div>
          <div class="filter_content">
            <div :class="['filter_c_item',filter.category_ids.indexOf(pItem.id ) != -1? 'filter_active_item' : '']"
              v-for="(pItem,pIndex) in $store.state.categoryConfig.invitation_notice" :key="pIndex" @click="chooseType(pItem,'category_ids')">
              <button class="filter_c_item_name">
                {{ pItem.name }}
              </button>
            </div>
          </div>
        </div>

        <div class="filter_box" slot="three">
          <div class="filter_title">
            时间:
          </div>
          <div class="filter_content">
            <div
              :class="['filter_c_item',(filter.start_time==pItem.start_time&&filter.end_time==pItem.end_time&&!diyTimeRange.length)? 'filter_active_item' : '']"
              v-for="(pItem,pIndex) in time_type" :key="pIndex" @click="chooseType(pItem,'start_time')">
              <button class="filter_c_item_name">
                {{ pItem.name }}
              </button>
            </div>
          </div>
        </div>
        <div class="filter_box" slot="three">
          <div class="filter_title">
            自定义时间:
          </div>
          <div class="filter_content">
            <el-date-picker v-model="diyTimeRange" @change="changeDiyTime" type="daterange" range-separator="-" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>
      </topFilterBox>
      <div class="list_box">
        <div class="lists_total_num_box">
          共找到<span>{{ list_data.total }}</span>条信息
        </div>
        <BidsList bidsType="invitation" :lists="list_data.lists" :numberRow="2" v-if="list_data.lists.length"></BidsList>
        <el-empty :image-size="200" v-else></el-empty>
      </div>
      <Pager @changePage="changePage" @getList="getData" :page_size="page.page_size" :total="list_data.total"></Pager>
    </div>
  </div>
</template>

<script>
import BidsList from '../../components/Bids/BidsList.vue';
import topFilterBox from '../../components/topFilterBox.vue';
import Pager from '../../components/pager/Pager.vue'
import mixin from '../../mixin/index'
import { mapState } from 'vuex';
export default {
  mixins: [mixin],
  components: {
    BidsList,
    topFilterBox,
    Pager
  },
  data () {
    return {
      bids_type: [
        { name: '招标预告', value: 0 },
        { name: '信息变更', value: 1 },
        { name: '答疑公告', value: 2 },
        { name: '重新招标', value: 3 },
        { name: '废标公告', value: 4 },
      ],
      time_type: [
        { name: '今日', value: 0, start_time: '', end_time: '' },
        { name: '近7天', value: 7, start_time: '', end_time: '' },
        { name: '近30天', value: 30, start_time: '', end_time: '' },
        { name: '近3个月', value: 90, start_time: '', end_time: '' },
        { name: '近6个月', value: 180, start_time: '', end_time: '' },
        { name: '近9个月', value: 270, start_time: '', end_time: '' },
      ],
      curBidsType: {

      },
      curTimeType: {

      },
      diyTimeRange: [],
      filter: {
        keyword: '',
        city_codes: [],
        category_ids: [],
        start_money: '',
        end_money: '',
        start_time: '',
        end_time: '',
        is_have_file: '',
      }
    }
  },
  created () {
    this.initDateArr();
    this.getData();
  },
  computed: {
    ...mapState({
      keyword: state => state.keyword,
    }),
  },
  methods: {
    chooseCity (val) {
      this.filter.city_codes = val;
      this.getData();
    },
    changeDiyTime (val) {
      if (val) {
        this.filter.start_time = val[0] + ' 00:00:00';
        this.filter.end_time = val[1] + ' 23:59:59';
      } else {
        this.filter.start_time = '';
        this.filter.end_time = '';
      }
      this.getData();

    },
    chooseType (val, type) {
      if (type == 'category_ids') {
        if (this.filter.category_ids.indexOf(val.id) == -1) {
          if (this.filter.category_ids.length >= 3) {
            this.$message.error('最多只能选择3个类型');
            return;
          }
          this.filter.category_ids.push(val.id);
        } else {
          this.filter.category_ids = this.filter.category_ids.filter(item => item != val.id);
        }
      }
      if (type == 'start_time') {
        if (this.filter.end_time == val.end_time) {
          this.filter.start_time = "";
          this.filter.end_time = "";
        } else {
          this.filter.start_time = val.start_time;
          this.filter.end_time = val.end_time;
        }
        this.diyTimeRange = [];
      }
      this.getData();
    },
    initDateArr () {
      this.time_type.forEach(item => {
        item.start_time = this.getDateWithOffset(item.value) + ' 00:00:00';
        item.end_time = this.getDateWithOffset(0) + ' 23:59:59';
      })
      console.log(this.time_type, '当前时间');
    },
    getData () {
      let params = {
        ...this.filter
      }
      params.city_codes += '';
      params.category_ids += '';
      if (this.keyword.length) {
        params.keyword = this.keyword;
      }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) {
          delete params[key];
        }
      }
      this.getList('getInvitationList', this.page, params);
    }
  },
  watch: {
    keyword (val) {
      this.filter.keyword = val;
      this.getData();
    }
  }
}
</script>

<style lang="scss">
.callBids {
  min-height: 100vh;
  padding-bottom: 92px;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .list_box {
    .lists_total_num_box {
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      margin: 24px 0 29px;
      span {
        color: #3f63ff;
      }
    }
  }
}
</style>